module.exports = __webpack_public_path__ + "static/media/port-adelaide-logo.40e3b877.svg";